import React, { useState } from 'react';
import { NotAssessed, SectionLabel } from '../shared/SurfaceParts';
import styles from '../ControlBridge.module.css';

/**
 * Salesperson phone/walk-in quote request (`co-kfo-pia-quote-request-entry-form-ddd-20261001`).
 * SPA collects fields; persist stays fail-closed until a dedicated write API is bound.
 */
export const QuoteRequestIntake: React.FC = () => {
  const [customerName, setCustomerName] = useState('');
  const [summary, setSummary] = useState('');
  const [submitted, setSubmitted] = useState(false);

  return (
    <section aria-label="Quote request" data-testid="quote-request-intake">
      <SectionLabel>Start a quote request</SectionLabel>
      <form
        className={styles.quoteRequestForm}
        onSubmit={(event) => {
          event.preventDefault();
          setSubmitted(true);
        }}
      >
        <label className={styles.reportIssueLabel} htmlFor="cb-quote-customer">
          Customer
        </label>
        <input
          id="cb-quote-customer"
          className={styles.reportIssueInput}
          value={customerName}
          onChange={(event) => setCustomerName(event.target.value)}
          required
          autoComplete="off"
          maxLength={120}
        />
        <label className={styles.reportIssueLabel} htmlFor="cb-quote-summary">
          Request
        </label>
        <textarea
          id="cb-quote-summary"
          className={styles.reportIssueTextarea}
          value={summary}
          onChange={(event) => setSummary(event.target.value)}
          required
          maxLength={500}
          rows={3}
        />
        <button type="submit" className={styles.reportIssuePrimary}>
          Save request
        </button>
      </form>
      {submitted ? (
        <NotAssessed label="Quote request persist" />
      ) : (
        <p className={styles.surfaceSubtitle}>
          Collects the walk-in request. Saving to the model waits on the write API.
        </p>
      )}
    </section>
  );
};
